var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealizado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6661 10.3277C23.0729 9.9155 23.7325 9.9155 24.1393 10.3277C24.5411 10.7349 24.546 11.3919 24.1541 11.8052L15.8314 21.6434C15.8234 21.6535 15.8148 21.6632 15.8058 21.6724C15.399 22.0846 14.7394 22.0846 14.3326 21.6724L9.26799 16.5403C8.86119 16.1281 8.86119 15.4598 9.26799 15.0475C9.6748 14.6353 10.3344 14.6353 10.7412 15.0475L15.0378 19.4014L22.6385 10.3593C22.647 10.3482 22.6563 10.3377 22.6661 10.3277Z",
    fill: "#7FC5ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666667,
    y: 0.666667,
    width: 30.6667,
    height: 30.6667,
    rx: 15.3333,
    stroke: "#7FC5ED",
    strokeWidth: 1.33333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealizado);
export default __webpack_public_path__ + "static/media/Realizado.e02e8f5462abf423da1f40b62a2ab210.svg";
export { ForwardRef as ReactComponent };